import React from 'react';
import Spinner from '@/components/ui/Spinner';
import {Tooltip} from '@/components/tooltips';
import useData from '@/utils/useData';
import {Icon} from '@/components/icons/Icon';
import {buildURL} from '@/utils/urlBuilder';

interface ConnectionInfo {
    connectionAcquired: boolean;
    reason: string;
}

interface EmailFetchAccountConnectionCheckProps {
    id: number;
}

const EmailFetchAccountConnectionCheck = React.memo<EmailFetchAccountConnectionCheckProps>(({
    id,
}) => {
    const [connectionInfo, loading] = useData<ConnectionInfo>(
        buildURL('emailFetchAccountConnectionCheckResource', {obj_id: id}),
        {
            useLocalStore: true,
        },
    );

    if (loading) {
        return (
            <Spinner variant="border" size="md" color="info" />
        );
    }

    let tooltipText: string;
    let icon: React.ReactElement;

    if (connectionInfo.connectionAcquired) {
        tooltipText = 'Connection acquired';

        icon = (
            <Icon name="mdi-check" className="text-success" />
        );
    } else {
        tooltipText = connectionInfo.reason;

        icon = (
            <Icon name="mdi-close" className="text-danger" />
        );
    }

    return (
        <Tooltip
            content={`${tooltipText}.`}
            placement="top"
        >
            {icon}
        </Tooltip>
    );
});

EmailFetchAccountConnectionCheck.displayName = 'EmailFetchAccountConnectionCheck';

export default EmailFetchAccountConnectionCheck; 